export default function NewProductsSlider() {
  return <h1>NewProductsSlider</h1>;
}
